import { axios } from "@Root/API";

export const postAdmissionsApplicationsFormStatus = (applicationId, formStatusId) => {
  return axios.post("change/form/status", {
    application_id: applicationId,
    forms_status_id: formStatusId
  });
};
